import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

import { CreatorsTitle } from './CreatorsTitle';
import { CreatorsVerticalName } from './CreatorsVerticalName';
import { CreatorsTopCreators } from './CreatorsTopCreators';
import { CreatorsLetterSelector } from './CreatorsLetterSelector';
import { CreatorsGroup } from './CreatorsGroup';
import { scrollToTop } from '../utils/scrollHelper';

import styles from './styles/CreatorsContent.scss';

function scrollToLetter(letter) {
    const el = document.getElementById(letter);
    scrollToTop(el, { offset: 64 });
}

function CreatorsContentComponent({ vertical, viewer }) {
    return (
        <div className={styles.wrapper}>
            <CreatorsTitle tagName="h1" dataTn="vertical">
                <CreatorsVerticalName vertical={vertical} />
            </CreatorsTitle>
            <CreatorsTopCreators viewer={viewer} vertical={vertical} />
            <div className={styles.groupedCreatorsWrapper}>
                <CreatorsLetterSelector
                    onLetterSelect={scrollToLetter}
                    creatorGroups={viewer.groupedCreators}
                />
                {(viewer.groupedCreators || []).map(group => (
                    <CreatorsGroup
                        creatorGroup={group}
                        key={group.groupName}
                        onLetterSelect={scrollToLetter}
                    />
                ))}
            </div>
        </div>
    );
}

CreatorsContentComponent.propTypes = {
    vertical: PropTypes.string.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const CreatorsContent = createFragmentContainer(CreatorsContentComponent, {
    viewer: graphql`
        fragment CreatorsContent_viewer on Viewer {
            ...CreatorsTopCreators_viewer
            groupedCreators(nationality: $nationality, style: $style, vertical: $vertical) {
                groupName
                ...CreatorsGroup_creatorGroup
                ...CreatorsLetterSelector_creatorGroups
            }
        }
    `,
});
